var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Malawi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#388e3c",
    d: "M42.716,31H5.284C8.125,38.588,15.421,44,24,44S39.875,38.588,42.716,31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M24,4C15.421,4,8.125,9.412,5.284,17h37.431C39.875,9.412,32.579,4,24,4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M44,24c0-2.467-0.468-4.818-1.284-7H5.284C4.468,19.182,4,21.533,4,24s0.468,4.818,1.284,7h37.431 C43.532,28.818,44,26.467,44,24z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M29.004,9.066c0.164-0.285,0.238-0.609,0.066-0.707c-0.191-0.109-0.422,0.133-0.582,0.41 c-0.398,0.688-0.512,1.082-0.91,2.172C28.324,10.051,28.609,9.746,29.004,9.066z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M29.059,12.078c0.953-0.668,1.309-0.887,1.863-1.441c0.23-0.234,0.387-0.527,0.246-0.668 c-0.156-0.156-0.441,0.02-0.668,0.246C29.937,10.777,29.727,11.129,29.059,12.078z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M25.125,7.707c0.027-0.324-0.043-0.652-0.242-0.668c-0.219-0.02-0.324,0.301-0.352,0.617 c-0.07,0.793-0.008,1.195,0.09,2.352C24.926,8.887,25.055,8.488,25.125,7.707z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M29.687,9.531c0.188-0.266,0.289-0.586,0.125-0.699c-0.176-0.125-0.43,0.098-0.613,0.359 c-0.457,0.652-0.602,1.035-1.094,2.082C28.926,10.453,29.238,10.176,29.687,9.531z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M25.941,7.844C26,7.52,25.957,7.188,25.762,7.152c-0.215-0.035-0.352,0.273-0.406,0.586 c-0.137,0.781-0.109,1.191-0.113,2.352C25.641,9,25.805,8.613,25.941,7.844z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M26.742,8.047c0.086-0.316,0.074-0.648-0.121-0.699c-0.211-0.059-0.371,0.238-0.453,0.547 c-0.207,0.766-0.215,1.176-0.316,2.332C26.344,9.176,26.539,8.805,26.742,8.047z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M27.527,8.32c0.109-0.309,0.125-0.641-0.059-0.711c-0.207-0.074-0.395,0.207-0.504,0.508 c-0.27,0.746-0.313,1.152-0.52,2.297C27.027,9.406,27.258,9.059,27.527,8.32z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M28.598,11.656c0.891-0.746,1.227-0.996,1.73-1.598c0.211-0.25,0.34-0.559,0.188-0.688 c-0.168-0.141-0.438,0.059-0.645,0.305C29.359,10.285,29.184,10.652,28.598,11.656z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M24,10.727c-2.789,0-5.156,1.785-6.035,4.273h12.074C29.156,12.512,26.789,10.727,24,10.727z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M30.723,14.688c1.145-0.199,1.559-0.25,2.297-0.516c0.309-0.113,0.574-0.316,0.508-0.504 c-0.078-0.203-0.41-0.168-0.711-0.059C32.07,13.883,31.73,14.113,30.723,14.688z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M31.52,15h1.598c0.043-0.012,0.082-0.02,0.129-0.031c0.316-0.086,0.598-0.266,0.547-0.457 c-0.059-0.211-0.395-0.203-0.703-0.121C32.492,14.551,32.141,14.711,31.52,15z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M30.195,13.559c1.094-0.395,1.492-0.516,2.172-0.91c0.285-0.164,0.512-0.41,0.41-0.582 c-0.105-0.188-0.43-0.094-0.707,0.066C31.383,12.531,31.086,12.816,30.195,13.559z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M30.484,14.113c1.121-0.301,1.531-0.387,2.242-0.719c0.297-0.137,0.543-0.363,0.461-0.543 c-0.094-0.195-0.422-0.129-0.711,0.004C31.754,13.191,31.437,13.449,30.484,14.113z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M29.859,13.031c1.055-0.488,1.441-0.645,2.086-1.094c0.27-0.188,0.473-0.453,0.359-0.613 c-0.125-0.18-0.441-0.059-0.703,0.125C30.953,11.906,30.684,12.215,29.859,13.031z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M29.48,12.535c1.008-0.578,1.379-0.766,1.98-1.27c0.254-0.211,0.434-0.492,0.305-0.645 c-0.141-0.168-0.445-0.02-0.688,0.188C30.469,11.32,30.23,11.648,29.48,12.535z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M28.281,8.66c0.141-0.297,0.184-0.625,0.004-0.711c-0.199-0.09-0.41,0.172-0.543,0.461 c-0.336,0.719-0.414,1.121-0.719,2.242C27.691,9.703,27.949,9.371,28.281,8.66z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M15.633,12.648c0.687,0.398,1.082,0.512,2.172,0.91c-0.891-0.746-1.195-1.031-1.875-1.426 c-0.281-0.164-0.609-0.238-0.707-0.066C15.113,12.258,15.355,12.488,15.633,12.648z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M16.055,11.938c0.652,0.457,1.035,0.602,2.086,1.094c-0.82-0.82-1.102-1.133-1.742-1.582 c-0.27-0.188-0.586-0.289-0.703-0.129C15.57,11.504,15.793,11.754,16.055,11.938z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M16.539,11.266c0.609,0.508,0.977,0.688,1.98,1.27c-0.746-0.887-0.996-1.223-1.598-1.727 c-0.25-0.211-0.559-0.34-0.688-0.188C16.094,10.789,16.293,11.059,16.539,11.266z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M24.297,7.645C24.297,7.316,24.199,7,24,7c-0.219,0-0.297,0.328-0.297,0.645 c0,0.797,0.098,1.195,0.297,2.336C24.203,8.84,24.297,8.43,24.297,7.645z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M14.98,14.172c0.746,0.27,1.156,0.313,2.297,0.52c-1.004-0.582-1.355-0.813-2.094-1.082 c-0.309-0.109-0.641-0.125-0.707,0.063C14.398,13.875,14.68,14.063,14.98,14.172z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M14.758,14.969c0.043,0.012,0.082,0.02,0.125,0.031h1.602c-0.625-0.293-0.984-0.449-1.574-0.609 c-0.316-0.082-0.648-0.07-0.699,0.121C14.152,14.723,14.449,14.887,14.758,14.969z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M19.402,11.656c-0.582-1.008-0.77-1.379-1.273-1.98c-0.211-0.254-0.492-0.434-0.645-0.305 c-0.168,0.141-0.02,0.441,0.188,0.688C18.184,10.668,18.516,10.906,19.402,11.656z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M15.273,13.395c0.719,0.336,1.121,0.414,2.242,0.719c-0.949-0.668-1.281-0.926-1.992-1.258 c-0.297-0.137-0.625-0.184-0.711-0.004C14.723,13.051,14.984,13.262,15.273,13.395z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M18.941,12.078c-0.668-0.953-0.887-1.309-1.441-1.863c-0.234-0.23-0.527-0.387-0.668-0.246 c-0.156,0.156,0.02,0.441,0.246,0.668C17.641,11.199,17.992,11.41,18.941,12.078z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M22.758,10.09c0-1.16,0.023-1.578-0.113-2.352c-0.055-0.324-0.207-0.621-0.406-0.586 c-0.215,0.039-0.234,0.375-0.18,0.691C22.195,8.625,22.363,9,22.758,10.09z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M19.895,11.273c-0.488-1.051-0.645-1.438-1.094-2.082c-0.188-0.27-0.453-0.473-0.613-0.359 c-0.18,0.125-0.059,0.441,0.125,0.699C18.77,10.184,19.078,10.453,19.895,11.273z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M23.375,10.008c0.102-1.156,0.164-1.57,0.094-2.352c-0.027-0.328-0.156-0.633-0.352-0.617 c-0.219,0.02-0.27,0.352-0.242,0.672C22.945,8.5,23.078,8.887,23.375,10.008z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M22.148,10.227c-0.102-1.156-0.113-1.578-0.316-2.336c-0.086-0.316-0.262-0.598-0.453-0.547 c-0.215,0.059-0.203,0.395-0.121,0.703C21.461,8.813,21.66,9.172,22.148,10.227z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M21.555,10.414c-0.203-1.145-0.25-1.559-0.52-2.297c-0.113-0.309-0.316-0.574-0.504-0.508 c-0.203,0.078-0.168,0.41-0.059,0.711C20.746,9.066,20.977,9.406,21.555,10.414z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M20.422,10.941c-0.395-1.094-0.516-1.492-0.91-2.172c-0.164-0.285-0.41-0.512-0.582-0.41 c-0.188,0.109-0.094,0.43,0.066,0.707C19.395,9.754,19.68,10.051,20.422,10.941z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M20.977,10.652c-0.301-1.121-0.387-1.531-0.719-2.242c-0.137-0.297-0.363-0.543-0.543-0.461 c-0.195,0.094-0.129,0.422,0.004,0.711C20.055,9.383,20.312,9.699,20.977,10.652z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Malawi);
export default __webpack_public_path__ + "static/media/icons8-malawi.91f158aed57202826cd162b6b046dd2d.svg";
export { ForwardRef as ReactComponent };